import fetch, { NewAxiosRequestConfig } from '@/utils/axios';
import qs from 'qs';
import { compatibleParams } from '@/utils/common/params';
import { handleCmsFetch, handlePinTop } from '@/components/component-pool/tools';
type ParamsType = {
  [key: string]: any;
};

type HomePageDataType = {
  lang: string;
  sales_org_id: string;
  zipcode?: string;
};

/**
 *
 * @param params
 * @param config
 * @returns
 */
export const getHomePageData = (params: HomePageDataType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/content/cms/page/sayweee_mobile_home', params, config);
};

/**
 * Latino首页数据
 * @param params
 * @param config
 * @returns
 */
export const getLatinoHomePageData = (params: HomePageDataType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/content/cms/page/latino_mobile_home', params, config);
};

/**
 * cms接口中返回的动态接口拼接参数后获取数据
 * @param url
 * @param params
 * @param config
 * @returns
 */
export const getHomePageDataByUrl = (
  url,
  params?: ObjectType,
  config?: NewAxiosRequestConfig,
  extraParams?: ObjectType
): Promise<AResponse> => {
  let _url = '';
  params = compatibleParams(params || {});
  params = handleCmsFetch(params);
  params = handlePinTop(params, config?.ctx);

  if (url?.includes('?')) {
    _url = `${url}&${qs.stringify(params)}`;
  } else {
    _url = `${url}${qs.stringify(params, { addQueryPrefix: true })}`;
  }
  return fetch.get(_url, extraParams || null, config);
};

export const getStoreTheme = (
  params: {
    store: string | number;
  },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/content/theme/v2', params, config);
};

/**
 * 服务协议数据
 * @param params
 * @param config
 * @returns
 */
export const getConfigInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/content/config/${params.configKey}`, {}, config);
};

/**
 * 活动查询
 * @param params
 * @param config
 * @returns
 */
export const getActivityPageData = (
  page_key: string | string[],
  params?: ParamsType,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get(`/ec/content/activity/${page_key}`, params, config);
};

/**
 * cms接口数据
 * @param params
 * @param config
 * @returns
 */
export const getLandingPageData = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/content/cms/page/activity/${params.key}`, params, config);
};
/**
 * new collection cms接口数据
 * @param params
 * @param config
 * @returns
 */
export const getCollection = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/content/collection/${params.key}`, params, config);
};

/**
 * target collection 页面数据
 * @param params
 * @param config
 * @returns
 */
export const getTargetedCollection = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/item/v1/ds_collection/target`, params, config);
};

/**
 * mkpl cms portal
 * @param params
 * @param config
 * @returns
 */
export const getCmsConfigData = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/content/cms/page/getPage`, params, config);
};

/**
 * mkpl cms share
 * @param params
 * @param config
 * @returns
 */
export const getCmsPageShare = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/content/cms/page/share`, params, config);
};

/**
 * vendor homePage
 * @param params
 * @param config
 * @returns
 */
export const getCmsPageVendorHomePage = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  let { vendorId, ...rest } = params;
  return fetch.get(
    `/ec/content/cms/page/getPage`,
    {
      ...rest,
      page_key: params?.vendorId,
      page_type: 6
    },
    config
  );
};

/** 获取global+ 页面数据  */
export const getGlobalCmsDate = (key: string, config?): Promise<AResponse> => {
  return fetch.get(`/ec/content/cms/page/getPage?page_type=8&page_key=${key}`, {}, config);
};

/**
 * 获取结算页面用户名提示
 * */
export const getDeliveryNameTips = (key: string, config?): Promise<AResponse> => {
  return fetch.get(`/ec/content/config/${key}`, {}, config);
};
